import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaPhone, FaEnvelope } from 'react-icons/fa';
import './styles/phoneAndContact.css';

function PhoneAndContact() {
    const location = useLocation();
    
    // Skjul knapperne på admin-sider, login og registrer
    if (location.pathname.startsWith('/admin') || 
        location.pathname === '/login' || 
        location.pathname === '/registrer') {
        return null;
    }

    return (
        <div className="floating-buttons">
            <a href="tel:+4542411633" className="floating-button phone">
                <FaPhone />
                <span>42 41 16 33</span>
            </a>
            <Link 
                to="/kontakt#kontaktformular" 
                className="floating-button contact"
                onClick={(e) => {
                    // Hvis vi allerede er på kontakt-siden
                    if (location.pathname === '/kontakt') {
                        e.preventDefault();
                        document.getElementById('kontaktformular')?.scrollIntoView({ 
                            behavior: 'smooth' 
                        });
                    }
                }}
            >
                <FaEnvelope />
                <span>Kontakt os</span>
            </Link>
        </div>
    );
}

export default PhoneAndContact;
